import React from 'react';
import styles from './GymRanking.module.css';

const GymRanking = ({ leaderboard }) => (
  <div className={styles.GymRanking}>
    <h3 className={styles.Title}>Gym Ranking by Sex</h3>
    <p className={styles.Subtitle}>Ranked against members of the same sex at your gym.</p>
    {leaderboard.map(pos => (
      <div key={pos.exercise} className={styles.Row}>
        <span className={styles.LiftName}>{pos.exercise}</span>
        <span className={styles.Rank}>
          {pos.rank ? `#${pos.rank}` : '-'}
        </span>
      </div>
    ))}
  </div>
);

export default GymRanking;
